import React from "react";
import { Link } from "react-router-dom";
import rocketImg from "../../images/RocketImage.png";

const styles = {
  hideDiv: {
    height: 0,
    maxHeight: 0,
    display: "none",
    overflow: "hidden",
    padding: "0px",
    boxShadow: "none",
  },
  rocketImageStyle: { height: "125px", width: "auto" },
};

const GameDescription = ({ expanded, setExpanded, showGameDesc }) => {
  return (
    <div
      className={`descriptionContainer ${expanded && "expanded"}`}
      style={showGameDesc ? { flex: 1, display: "flex" } : styles.hideDiv}
    >
      <p className="headerText">The Game</p>
      <div className="customHl" />
      <div className="descriptionImageWrapper">
        <img
          src={rocketImg}
          alt="rocketImage"
          style={styles.rocketImageStyle}
        />
      </div>
      {expanded ? (
        <React.Fragment>
          <p className="descriptionText">
            This is a tower defence inspired game for tablets which is played by
            using three custom tangibles and your fingers. It was originally
            thought to work on all tablets but during development we focused on
            recent ipads as they had the most sensitive screens. Although not
            sure, the game might be able to work on other kinds of tablets with
            some alterations. The plot of the game is that you are stuck on a
            strange planet with aliens trying to destroy your base. You must
            protect your base by shooting the aliens with your tanks and
            blocking their passage using energy shields. The aliens spawn in
            waves, so you will have some time in between the waves to upgrade
            your tanks or place new energy shields.
          </p>
          <p className="descriptionTitle">Aliens:</p>
          <p className="descriptionText">
            There are three different kinds of aliens; The blue arm-flinger, the
            red arm-flinger and the stone golem. The arm-flingers share the same
            3D model, but the red one is made larger, does more damage and has
            more health than the blue one. The stone golem is the strongest of
            the bunch, hard to kill and hard hitting. Each alien grants
            different resources when killed, the stone golem is worth the most.
          </p>
          <p className="descriptionTitle">Resources:</p>
          <p className="descriptionText">
            A resource system is in place where you get resources from either
            killing aliens or mining crystals. The resources can be used to
            either build energy shields which will last for around 60 seconds,
            or upgrade your tangibles. The tangibles are upgraded individually,
            each can have it’s fire rate or damage upgraded four times. Each
            upgrade costs 50 in-game dollars. There are three different kinds of
            crystals each with its own value. They spawn at random positions on
            the map every 10 seconds and are visible for 7 seconds before
            disappearing. They are “mined” by the player simply by touching it
            with a finger.
          </p>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <p className="descriptionText">
            <strong>OH SHIT!</strong> During a standard intergalactic procedure
            you’ve managed to land on an alien infested planet!? Grab your
            physical tangibles and your tablet to defend your spaceship before
            it’s too late!
          </p>

          <p className="descriptionText">
            This is a school project created by a{" "}
            <Link to="/about">team of five</Link> for the course{" "}
            <a
              href={"https://www.kth.se/social/course/DH2413/"}
              target="_blank"
              rel="noopener noreferrer"
            >
              DH2413 Advanced Graphics and Interaction
            </a>{" "}
            at KTH, Sweden. Its built in Unity with scripting done in C# and
            models created in Blender.
          </p>
        </React.Fragment>
      )}

      <button
        className="readMoreButton"
        onClick={() => setExpanded(expanded ? false : "Game")}
      >
        {expanded ? "Close" : "Read More"}
      </button>
    </div>
  );
};

export default GameDescription;
